module.exports = __webpack_public_path__ + "static/img/jkyp.3c972f2a.png";